var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNeu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 46,
    viewBox: "0 0 180 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.381 10.3911H77.9768L70.5086 31.4824L63.0403 10.3911H57.6362L68.4445 38.125H72.6477L83.381 10.3911ZM90.6314 38.125V17.334H85.6401V38.125H90.6314ZM90.6689 14.3317V9.34032H85.6776V14.3317H90.6689ZM99.6472 38.125V10.3911H94.6558V38.125H99.6472ZM108.663 38.125V10.3911H103.672V38.125H108.663ZM117.679 38.125V17.334H112.687V38.125H117.679ZM117.716 14.3317V9.34032H112.725V14.3317H117.716ZM142.757 38.125V17.334H138.178V20.1111C136.452 17.8219 134.388 16.8461 131.385 16.8461C125.231 16.8461 120.802 21.4622 120.802 27.8045C120.802 34.0719 125.193 38.6129 131.273 38.6129C134.2 38.6129 136.189 37.6747 138.178 35.4229V38.125H142.757ZM138.028 27.8796C138.028 31.3323 135.776 34.0343 131.986 34.0343C128.346 34.0343 125.831 31.5574 125.831 27.9171C125.831 24.1267 128.346 21.4246 131.911 21.4246C135.476 21.4246 138.028 24.0892 138.028 27.8796ZM177.665 38.125V26.1157C177.665 19.8859 174.737 16.8461 169.258 16.8461C166.331 16.8461 164.267 17.8219 162.578 20.0736C161.152 17.8219 159.313 16.8461 156.461 16.8461C154.021 16.8461 152.52 17.5216 151.056 19.2855V17.334H146.478V38.125H151.469V27.8796C151.469 22.9633 152.633 21.4246 155.522 21.4246C158.149 21.4246 159.576 22.6256 159.576 26.7162V38.125H164.567V27.8796C164.567 22.9258 165.993 21.4246 168.77 21.4246C171.097 21.4246 172.673 22.5505 172.673 26.7162V38.125H177.665Z",
    fill: "#13294B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_745_3069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 22.9382C0.15625 10.272 10.4243 0.00390625 23.0906 0.00390625H39.7702C43.2246 0.00390625 46.025 2.80428 46.025 6.25873V39.6177C46.025 43.0722 43.2246 45.8725 39.7702 45.8725H6.41107C2.95662 45.8725 0.15625 43.0722 0.15625 39.6177V22.9382Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 22.9382C0.15625 10.272 10.4243 0.00390625 23.0906 0.00390625H39.7702C43.2246 0.00390625 46.025 2.80428 46.025 6.25873V39.6177C46.025 43.0722 43.2246 45.8725 39.7702 45.8725H6.41107C2.95662 45.8725 0.15625 43.0722 0.15625 39.6177V22.9382Z",
    fill: "url(#paint0_linear_745_3069)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_745_3069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 22.9382C0.15625 10.272 10.4243 0.00390625 23.0906 0.00390625H39.7702C43.2246 0.00390625 46.025 2.80428 46.025 6.25873V39.6177C46.025 43.0722 43.2246 45.8725 39.7702 45.8725H6.41107C2.95662 45.8725 0.15625 43.0722 0.15625 39.6177V22.9382Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.15625 22.9382C0.15625 10.272 10.4243 0.00390625 23.0906 0.00390625H39.7702C43.2246 0.00390625 46.025 2.80428 46.025 6.25873V39.6177C46.025 43.0722 43.2246 45.8725 39.7702 45.8725H6.41107C2.95662 45.8725 0.15625 43.0722 0.15625 39.6177V22.9382Z",
    fill: "url(#paint1_linear_745_3069)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.72973,
    height: 53.3975,
    rx: 1.38996,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 24.4688 7.67578)",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.103843,
    y: 0.222691,
    width: 9.38224,
    height: 53.05,
    rx: 1.21622,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 24.5512 7.6537)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.34749
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.72973,
    height: 26.8331,
    rx: 1.38996,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 5.70312 18.4805)",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.103843,
    y: 0.222691,
    width: 9.38224,
    height: 26.4856,
    rx: 1.21622,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 5.78555 18.4584)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.34749
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.72973,
    height: 73.2486,
    rx: 1.38996,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 43.8594 -4.83984)",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.103843,
    y: 0.222691,
    width: 9.38224,
    height: 72.9011,
    rx: 1.21622,
    transform: "matrix(0.939693 0.34202 -0.342021 0.939692 43.9418 -4.86193)",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 0.34749
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_745_3069",
    x1: 41.4503,
    y1: -6.77214,
    x2: 14.1724,
    y2: 39.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_745_3069",
    x1: 41.4503,
    y1: -6.77214,
    x2: 14.1724,
    y2: 39.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNeu);
export default __webpack_public_path__ + "static/media/logo_neu.8dce09af8f8c4215ded7b81ffe5f2979.svg";
export { ForwardRef as ReactComponent };